import { Controller } from "stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
	connect() {
		this.tag     = "[BatchCalendarController]";
		this.similar = null;

		console.log(this.tag, "Connected");
		this.connectResize();
	}

	connectResize() {
		try {
			console.log(this.tag, "Connecting resize ...");
			const ref = this;

			if (!window.calendar) {
				console.error(this.tag, "No calendar found");
			}

			window.calendar.setOption('eventResize', (info) => {
				ref.handleEventResize(info);
			});
		} catch (e) {
			console.error(this.tag, "Error connecting drag stop", e);
		}
	}

	handleEventResize(info) {
		try {
			const component_id = parseInt(info.event.extendedProps.extras.component_id);
			const lesson_id    = parseInt(info.event.extendedProps.extras.lesson_id);
			console.log(this.tag, "Event resize stop for component " + component_id + " and lesson " + lesson_id, info);

			/*
			// commented for reference
			const old_start_hours = info.oldEvent.start;
			const old_end_hours   = info.oldEvent.end;
			const old_hours       = (old_end_hours - old_start_hours) / 1000 / 60 / 60;
			const start_hours     = info.event.start;
			const end_hours       = info.event.end;
			const new_hours       = (end_hours - start_hours) / 1000 / 60 / 60;
			const needed_hours    = new_hours - old_hours;
			*/

			const evaluator   = new BatchCalendarEvaluator(component_id, lesson_id);
			const max_hours   = evaluator.getMaxHours();
			const total_hours = evaluator.getTotalHours();
			console.log(this.tag, "Max hours " + max_hours + ", total hours " + total_hours);

			if (total_hours > max_hours) {
				info.revert();
				throw "Não há espaco disponível";
			}
		} catch (e) {
			console.error(this.tag, "Error on event resize stop", e);
			Swal.fire({ title: 'Atenção', text: e });
		}
	}

	submit(evt) {
		try {
			console.log(this.tag, "Submit");

			const evaluator = new BatchCalendarEvaluator(
				parseInt(document.querySelector("#component_tab > a.text-indigo-600")?.dataset?.objectId),
				parseInt(document.querySelector("#batch_schedule_component_lesson_id option:checked")?.dataset?.lessonId)
			);
			evaluator.eval();

			/*
			const start_timestamp = new Date(document.getElementById("batch_schedule_date").value + "T" + document.getElementById("batch_schedule_start_time").value);
			const end_timestamp = new Date(document.getElementById("batch_schedule_date").value + "T" + document.getElementById("batch_schedule_end_time").value);
			const clone = {
				...evaluator.similar.toPlainObject(),
				id: null,
				start: start_timestamp,
				end: end_timestamp
			};

			console.log(this.tag, "Inserting new event", clone);
			window.calendar.addEvent(clone);
			evt.preventDefault();

			const turboFrame = document.querySelector('#turbo-scheduler-modal')
			if (turboFrame) {
				turboFrame.innerHTML = ''
			}
			*/
		} catch (e) {
			console.error(this.tag, "Error on submit", e);
			Swal.fire({ title: 'Atenção', text: e });
			evt.preventDefault();
			return false;
		}
	}

	getTotalHours(component, lesson) {
		try {
			console.log(this.tag, "Getting total hours for component " + component + " and lesson " + lesson);
			const ref = this;

			return window.calendar.getEvents().map((element) => {
				return {
					start: element.start,
					end: element.end,
					component: element._def.extendedProps.extras.component_id,
					lesson: element._def.extendedProps.extras.lesson_id,
					element: element
				}; })
				.filter((element) => { return element.component == component && element.lesson == lesson})
				.reduce((memo, element) => { ref.similar = element.element; console.log(element.element); return memo + ((element.end - element.start) / (1000 * 60 * 60)); }, 0);
		} catch (e) {
			console.error(this.tag, "Error getting total hours", e);
			return 0;
		}
	}
}
